// extracted by mini-css-extract-plugin
export default {"container":"IBSkills__container___rVJlb","skillsContainer":"IBSkills__skillsContainer___rUo3P","overlayContainer":"IBSkills__overlayContainer___IFUM5"};